import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { createModule } from "../config.js";
import { useEventCallback, useLoseFocus, useRTL, useThrottle } from "../hooks/index.js";
import { cssClass, getNavigationAnimationDuration, label as translateLabel } from "../utils.js";
import { IconButton, NextIcon, PreviousIcon } from "../components/index.js";
import { useEvents, useLightboxState } from "../contexts/index.js";
import { useController } from "./Controller.js";
import { ACTION_NEXT, ACTION_PREV, EVENT_ON_KEY_DOWN, MODULE_NAVIGATION, VK_ARROW_LEFT, VK_ARROW_RIGHT } from "../consts.js";
export function NavigationButton(_ref) {
  var labels = _ref.labels,
      label = _ref.label,
      icon = _ref.icon,
      renderIcon = _ref.renderIcon,
      action = _ref.action,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return React.createElement(IconButton, _objectSpread({
    label: translateLabel(labels, label),
    icon: icon,
    renderIcon: renderIcon,
    className: cssClass("navigation_".concat(action)),
    disabled: disabled,
    onClick: onClick
  }, useLoseFocus(disabled)));
}
export function Navigation(_ref2) {
  var slides = _ref2.slides,
      finite = _ref2.carousel.finite,
      animation = _ref2.animation,
      labels = _ref2.labels,
      _ref2$render = _ref2.render,
      buttonPrev = _ref2$render.buttonPrev,
      buttonNext = _ref2$render.buttonNext,
      iconPrev = _ref2$render.iconPrev,
      iconNext = _ref2$render.iconNext;
  var currentIndex = useLightboxState().state.currentIndex;

  var _useController = useController(),
      subscribeSensors = _useController.subscribeSensors;

  var _useEvents = useEvents(),
      publish = _useEvents.publish;

  var isRTL = useRTL();
  var prevDisabled = slides.length === 0 || finite && currentIndex === 0;
  var nextDisabled = slides.length === 0 || finite && currentIndex === slides.length - 1;
  var publishThrottled = useThrottle(function (action) {
    return publish(action);
  }, getNavigationAnimationDuration(animation) / 2);
  var handleKeyDown = useEventCallback(function (event) {
    if (event.key === VK_ARROW_LEFT && !(isRTL ? nextDisabled : prevDisabled)) {
      publishThrottled(isRTL ? ACTION_NEXT : ACTION_PREV);
    }

    if (event.key === VK_ARROW_RIGHT && !(isRTL ? prevDisabled : nextDisabled)) {
      publishThrottled(isRTL ? ACTION_PREV : ACTION_NEXT);
    }
  });
  React.useEffect(function () {
    return subscribeSensors(EVENT_ON_KEY_DOWN, handleKeyDown);
  }, [subscribeSensors, handleKeyDown]);
  return React.createElement(React.Fragment, null, buttonPrev ? buttonPrev() : React.createElement(NavigationButton, {
    label: "Previous",
    action: ACTION_PREV,
    icon: PreviousIcon,
    renderIcon: iconPrev,
    disabled: prevDisabled,
    labels: labels,
    onClick: function onClick() {
      return publish(ACTION_PREV);
    }
  }), buttonNext ? buttonNext() : React.createElement(NavigationButton, {
    label: "Next",
    action: ACTION_NEXT,
    icon: NextIcon,
    renderIcon: iconNext,
    disabled: nextDisabled,
    labels: labels,
    onClick: function onClick() {
      return publish(ACTION_NEXT);
    }
  }));
}
export var NavigationModule = createModule(MODULE_NAVIGATION, Navigation);